/** Titled card wrapper for grouping related form fields — settings/edit pages. */
export function SectionCard({
  title,
  children,
  danger,
}: {
  title: string
  children: React.ReactNode
  danger?: boolean
}) {
  return (
    <div
      style={{
        background: 'var(--surface)',
        borderRadius: 'var(--radius-md)',
        boxShadow: 'var(--shadow-card)',
        padding: 20,
        marginBottom: 16,
        ...(danger ? { border: '1px solid var(--danger)' } : {}),
      }}
    >
      <h2
        style={{
          fontSize: 'var(--fs-body-lg)',
          fontWeight: 700,
          color: 'var(--text-strong)',
          marginBottom: 16,
          marginTop: 0,
          fontFamily: 'var(--font-sans)',
        }}
      >
        {title}
      </h2>
      {children}
    </div>
  )
}
